import { Box, type BoxProps } from '@mui/material'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'

// data-sui-dash lets the DataGrid theme tint the dash tertiary inside cells (Dash stays
// `inherit` elsewhere). After the spread so callers can't drop the marker.
export const Dash: React.FC<BoxProps> = ({ sx, ...props }) => (
  <Box component="span" {...props} data-sui-dash={true} sx={mergeSx({ color: 'inherit' }, sx)}>
    —
  </Box>
)
